import React, { useState } from "react";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";

import { useNavigate } from "react-router-dom";
import { t } from "i18next";
import { useTranslation } from "react-i18next";
import { useLogout } from "../../hooks/useLogout";
const ProfileMenu = () => {
  const [menu, setMenu] = useState(false);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { setLogout } = useLogout();

const storedAdmin = localStorage.getItem("admin");
let admin = {};
try {
  admin = storedAdmin ? JSON.parse(storedAdmin) : {};
} catch (err) {
  admin = {};
}

const displayName = admin?.name || admin?.username || "User";
const firstChar = displayName.charAt(0).toUpperCase() || "?";


  return (
    <React.Fragment>
      <Dropdown
        isOpen={menu}
        toggle={() => setMenu(!menu)}
        className="d-inline-block"
      >
        <DropdownToggle
          style={{ display: "flex", gap: "10px", alignItems: "center" }}
          className="btn header-item "
          id="page-header-user-dropdown"
          tag="button"
        >
          <div className="rounded-circle header-profile-user">
            <span className="avatar-title rounded-circle bg-info text-white font-size-16">
              {firstChar}
            </span>
          </div>
          <div>
            <span className="d-none d-xl-block">{displayName}</span>
          </div>
        </DropdownToggle>
        <DropdownMenu className="dropdown-menu-end">
          {/* <DropdownItem
            tag="a"
            onClick={() => {
              navigate("/edit-profile");
            }}
          >
            <i className="bx bx-user font-size-16 align-middle me-1" />
            {t("pages.Profile")}
          </DropdownItem> */}

          {/* <div className="dropdown-divider" /> */}
          <DropdownItem
            onClick={() => {
              setLogout(true);
            }}
            className="dropdown-item"
          >
            <i className="bx bx-log-out font-size-16 align-middle me-1 text-danger"></i>
            <span>{t("btns.logout")}</span>
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  );
};

export default ProfileMenu;
